import React from 'react';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const PricingCard = ({ 
  plan, 
  isRecommended = false, 
  onSelectPlan 
}) => {
  const {
    name,
    price,
    billing,
    description,
    features,
    buttonText,
    buttonVariant = 'default'
  } = plan;

  return (
    <div className={`relative bg-card rounded-xl border-2 p-8 transition-all duration-300 hover:shadow-modal ${
      isRecommended 
        ? 'border-primary shadow-lg scale-105' 
        : 'border-border hover:border-primary/50'
    }`}>
      {isRecommended && (
        <div className="absolute -top-4 left-1/2 transform -translate-x-1/2">
          <div className="bg-primary text-primary-foreground px-4 py-2 rounded-full text-sm font-semibold">
            Most Popular
          </div>
        </div>
      )}
      <div className="text-center mb-8">
        <h3 className="text-2xl font-bold text-text-primary mb-2">{name}</h3>
        <div className="mb-4">
          <span className="text-4xl font-bold text-text-primary">${price}</span>
          <span className="text-text-secondary ml-2">/{billing}</span>
        </div>
        <p className="text-text-secondary text-sm">{description}</p>
      </div>
      <div className="space-y-4 mb-8">
        {features?.map((feature, index) => (
          <div key={index} className="flex items-start space-x-3">
            <div className="flex-shrink-0 mt-0.5">
              <Icon 
                name="Check" 
                size={16} 
                color="var(--color-success)" 
                className="bg-success/10 rounded-full p-1" 
              />
            </div>
            <span className="text-text-primary text-sm leading-relaxed">
              {feature}
            </span>
          </div>
        ))}
      </div>
      <Button
        variant={buttonVariant}
        size="lg"
        fullWidth
        onClick={() => onSelectPlan(plan)}
        className="font-semibold"
      >
        {buttonText}
      </Button>
    </div>
  );
};

export default PricingCard;